import React, { useEffect } from "react";
import "./Components/App.css";
import { Route, Routes } from "react-router-dom";

import Home from "./Components/Home";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Project from "./Components/Project";
import Project_Data from "./Components/Project_Data";
import Services from "./Components/Services";
import BgHover from "./Components/BgHover";

import Lenis from "@studio-freight/lenis";
import CustomCursor from "./Components/CustomCursor";

function App() {
 /*  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []); */
 useEffect(() => {
   const lenis = new Lenis({
     duration: 1.2,
     easing: (t) => t,
     smooth: true,
     direction: "vertical",
     gestureDirection: "vertical",
   });

   const raf = (time) => {
     lenis.raf(time);
     requestAnimationFrame(raf);
   };
   requestAnimationFrame(raf);
 }, []);
  return (
    <>
      <CustomCursor />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Project />} />
        <Route path="/projects/:id" element={<Project_Data />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/bg" element={<BgHover />} />
        <Route path="*" element={"nothing to show"} />
      </Routes>
    </>
  );
}

export default App;
